import { render, staticRenderFns } from "./AddDocumentRepresentationToConversationDetailComponent.vue?vue&type=template&id=ad581560&scoped=true&"
import script from "./AddDocumentRepresentationToConversationDetailComponent.vue?vue&type=script&lang=js&"
export * from "./AddDocumentRepresentationToConversationDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentRepresentationToConversationDetailComponent.vue?vue&type=style&index=0&id=ad581560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad581560",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCheckbox,VCol,VRadio,VRadioGroup,VRow,VSelect,VTextField})
